
document.addEventListener('DOMContentLoaded', function () {
    ((doc)=>{
        let myDoc = doc;

        Fancybox.bind('[data-fancybox="gallery1"]');
        Fancybox.bind('[data-fancybox="gallery2"]');



        let staffSlider = myDoc.querySelectorAll('.splideGallerySingleImage');
        if(staffSlider){
            Object.keys(staffSlider).forEach(i => {
                var staffSplide = new Splide( staffSlider[i], {
                    gap: 0,
                    arrows : true,
                    pagination: true,
                    //arrowPath : 'm13.4 8.4c0.6-0.5 1.6-0.5 2.2 0l10.5 10.6c0.6 0.6 0.6 1.5 0 2.1l-10.5 10.5c-0.6 0.6-1.6 0.6-2.2 0-0.5-0.6-0.5-1.5 0-2.1l9.5-9.5-9.5-9.4c-0.5-0.6-0.5-1.6 0-2.2z',
                    focus  : 'center',
                    mediaQuery: 'min',
                    fixedHeight : '286px',
                    perPage: 1,
                    focus: 0,
                    classes: {
                        // Add classes for pagination.
                        pagination: 'splide__batch duo rounded-pill position-absolute text-small text-white d-flex justify-content-center end-0 top-0 mt-2 me-1 me-md-2 p-1', // container
                        page      : 'bg-transparent border-0 text-white p-0 lh-1', // each button
                    },
                    breakpoints: {
                        576: {
                            omitEnd: true,
                            fixedHeight : '468px',
                        },
                        992: {
                            fixedHeight : '347px'
                        },
                        1200: {
                            fixedHeight : '569px'
                        }
                    }
                });
                staffSplide.mount();
                let liCounter = () => {
                    let dot = staffSlider[i].querySelector('.splide__batch');
                    dot.setAttribute('data-count', dot.querySelectorAll('li').length);
                    dot.querySelectorAll('li').forEach((item, index) => {
                        item.querySelector('button').innerHTML = index + 1;
                    });
                };
                liCounter();
                staffSplide.on('resize', ()=>{
                    liCounter();
                });
            });
        }


        let splideReview = myDoc.querySelectorAll('.splideReview');
        if(splideReview){
            splideReview.forEach(reviewItem => {
                var reviewSplide = new Splide( reviewItem, {
                    gap        : 8,
                    arrows     : false,
                    pagination : false,
                    mediaQuery  : 'min',
                    destroy: false,
                    padding: '1rem',
                    focus  : 'center',
                    breakpoints: {
                        768: {
                            perPage: 2,
                        },
                        992: {
                            destroy: true,
                        }
                    }
                });
                reviewSplide.mount();
            })
        };

        let youmaulike = myDoc.querySelectorAll('.homeStaffSlide');
        if(youmaulike){
            Object.keys(youmaulike).forEach((ele)=>{
                var staffSplide = new Splide( youmaulike[ele], {
                    gap: 4,
                    arrows : false,
                    pagination: false,
                    //destroy: false,
                    mediaQuery: 'min',
                    classes: {
                        pagination: 'splide__pagination position-relative bottom-0 d-flex justify-content-md-end justify-content-center mt-4 px-0',
                        page      : 'splide__pagination--page border-0 rounded-circle mx-1',
                    },
                    breakpoints: {
                        576: {
                            fixedWidth  : '338px',
                        },
                        768: {
                           // gap: 8,
                            omitEnd: true,
                        },
                        992: {
                            //destroy: true,
                            padding: '1rem',
                            focus: 'center',
                        }
                    }
                });
                staffSplide.mount();
            })
        }

    })(document);
}, false);

